var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-appbar',[_vm._v(" Ordem Carregamento ")])
}
var staticRenderFns = []

export { render, staticRenderFns }